"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.palette = void 0;
exports.palette = {
    white: '#FFFFFF',
    black: '#000000',
    darkGray: '#83808F',
    gray: '#F4F3F5',
    darkBlue: '#21145A',
    blue: '#0E91E4',
    red: '#E85668',
    green: '#76C198',
    greenLight: '#44FDAF',
    darkBlue2: '#1F232B',
    neutral: '#DCE1EF',
    neutral10: '#F1F2F6',
    neutral20: '#E4E7EE',
    neutral30: '#DCE1EF',
    danger100: '#F3566A',
    danger20: '#FDDDE1',
    tertiary: '#1698D9',
    secondaryGray: '#63779C',
    secondaryGray2: '#737B8C',
    secondaryLightGray: '#A2ADC1',
    secondaryLightGray2: '#EAEAEA',
    textDisabled: '#8591A9',
};
